import type { TransfersPayload } from './types';

export interface TransfersQuery {
  from: string;
  to: string;
  sid?: number | null;
  limit?: number;
}

/**
 * v2.36 — inter-store transfer cycle: stkxfr shipments, counterpart-supplier
 * receipts, and the per-part reconciliation between both legs.
 */
export async function fetchTransfers(q: TransfersQuery): Promise<TransfersPayload> {
  const params = new URLSearchParams({ from: q.from, to: q.to });
  if (q.sid) params.set('sid', String(q.sid));
  if (q.limit) params.set('limit', String(q.limit));
  const res = await fetch(`/api/transfers?${params}`, { credentials: 'same-origin' });
  if (!res.ok) {
    throw new Error(res.status === 502 || res.status === 503
      ? '503: daemon offline'
      : `transfers failed: ${res.status}`);
  }
  return (await res.json()) as TransfersPayload;
}
